import { render, staticRenderFns } from "./DashboardDesktop.vue?vue&type=template&id=36ce54c6&scoped=true"
import script from "./DashboardDesktop.vue?vue&type=script&lang=js"
export * from "./DashboardDesktop.vue?vue&type=script&lang=js"
import style0 from "./DashboardDesktop.vue?vue&type=style&index=0&id=36ce54c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ce54c6",
  null
  
)

export default component.exports